The job ad ID to update.
